import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogComponent } from "../../common/DialogComponent";
import EFTDialog from "../EFTDialog";
import ProtectionPlanBillingInfo from "./ProtectionPlanBillingInfo";
import ProtectionPlanTermsAndCondition from "./ProtectionPlanTermsAndCondition";
import * as services from "../../../store/service";
import parse, { domToReact } from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { IPackage } from "../../../store/protectionPlanService/ezs/types";
import { Notification } from "../../common/Notification";
import LegalDocumentContainer from "../../LegalDocumentPages/LegalDocumentContainer";
import * as MyAccountActions from "../../../store/myAccount/actions";
import * as LoginActions from "../../../store/loginService/actions";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import WhatYouNeedToKnow from "../../common/WhatYouNeedToKnow";
import { getUpgradeDowngradeValue } from "./GetUpgradeDowngradeCommonFunctions";
import { useTranslation } from "react-i18next";
import { stateDisclosureAPI } from "./GetStateLegalDisclaimer";
import ProtectionPlanUpgradeCompleteDialog from "./ProtectionPlanUpgradeCompleteDialog";
import { CheckNonCreditServicesForNCDisclaimer } from "./NonCreditServicesForNCDisclaimer";

interface IProps {
    closeDialog: any;
    dialogId: string;
    packageIndex: number;
    closeUpgradeAndOpenCompletionDialog: any;
    subscriptionTypeChange: boolean;
    setBillingInfoRequest: any;
    setBillingInfoChanged: any;
    payAsYouGoPackageDetails?: any;
    removedFamilyMembers?: any;
    addedFamilyMembers?: any;
    isTwoStepCancellation:boolean;
}
const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});
const ProtectionPlanUpgradePackage: React.FunctionComponent<IProps> = (props) => {
    const { getTermsOfUseURL, getPrivacyNoticeURL, getPrivacyNoticeLinkText, getTermsOfUseLinkText } = LegalDocumentContainer();
    const dispatch = useDispatch();
    const [showBillingInfoDialog, setShowBillingInfoDialog] = useState(false);
    const [checkNonCredit, setCheckNonCredit]: any = useState("");
    const [tncDialog, setTncDialog] = useState(false);
    const [EFTdialog, setEFTDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState<any>({ EFTData: [], isEFTChecked: false });
    const [termsData, setTermsData] = useState<any>(null);
    const [loadingPaymentInfo, setLoadingPaymentInfo] = useState(false);
    const [loadingAmountDetail, setLoadingAmountDetail] = useState(false);
    const [loadingTnc, setLoadingTnc] = useState(false);
    const [disableButton, setDisableButton] = useState(true);
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const packageList = useSelector((state: ApplicationState) => {
        if (state.protectionPlanState && state.protectionPlanState.protectionPlanData) {
            return state.protectionPlanState.protectionPlanData.packageList;
        }
    });
    const currentPackage = packageList?.find((pkg) => pkg.IsActive);
    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;
    let checkupgradedowngrade: string = "";
    const [paymentMethodDetails, setPaymentMethodDetails] = useState<any>();
    const getFamilyOffer = () => dispatch(MyAccountActions.actionCreators.GetFamilyOffer());
    const getFamilyMembers = () => dispatch(LoginActions.actionCreators.getFamilyMembers(true));
    const [paymentInfoState, setPaymentInfoState] = useState({
        name: "",
        cardOrAccNumber: "",
        exp: "",
        paymentMethod: "",
        address: {
            addressline1: "",
            addressline2: "",
            city: "",
            state: "",
            zipCode: "",
        },
    });

    const toggleDisableButton = () => {
        setDisableButton(!disableButton);
    };
    const [serviceListOfSelectedPackage, setServiceListOfSelectedPackage]: any = useState([""]);
    const [payAsYouGoAmountDetailsState, setPayAsYouAmountDetailsState]: any = useState();
    const [amountDetailState, setAmountDetailState] = useState({
        difference: 0,
        currentCharge: 0,
        amountTobeCreditedOrCharged: 0,
        creditedAmount: 0,
        newCharge: 0,
        nextBillingDate: "",
        billingCycleDescription1: "",
        billingCycleDescription2: "",
        billingCycleDescription3: "",
        tax: "",
        familyProtectionCharge: "",
        planCost: 0,
        totalCost: 0,
        familyProtectionCostPerMember: 0,
        refundAmount: 0,
        todaysNetCharge:null
    });
    const [proofInfo, setProofInfo] = useState({
        checkBoxAcceptance: "",
        continueButtonAcceptance: ""
    });
    const [showDisclosure, setShowDisclosure] = useState(false);
    const [disclosureText, setDisclosureText]: any = useState("");
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand === "true"
                ? true
                : false
            : false
    );
    const isUserPaid = useSelector((state: ApplicationState) =>
        state.myAccountServiceState ? state.myAccountServiceState.familtOffer?.familyAdultOffer?.isUserPaid : false
    );
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );

    const showDisclosureStatus = (value: boolean) => {
        setShowDisclosure(value);
    };

    const [householdMembers] = useState(
        familyMembers.filter((x) => x.accountType === "Family Plan Adult") ? familyMembers.filter((x) => x.accountType === "Family Plan Adult") : []
    );
    const { t: tLang } = useTranslation();

    const offerPriceData = useSelector((state: ApplicationState) =>
        state.checkContractChangeState?.cancellatinoContinuationData?.OfferPrice);

    const [isCompleted, setCompletion] = useState(false);
    const [isLoader, setLoader] = useState(true);
    const [refundState, setRefundState] = useState({
        packageIndex: -1,
        billingLabel: "",
        bilingAmount: 0,
        billingText: "",
        subscriptionType: "",
        subscriptionCharge: "",
        salesTax: "",
        newCharge: "",
    });
    const handleBillingCloseDialog = (value: string): any => {
        if (value === "show") {
            setShowBillingInfoDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
            getPaymentDetailsData();
        }
    };

    const storeTimestampCheckbox = (): any => {
        let prooftime = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
        setProofInfo({ ...proofInfo, checkBoxAcceptance: prooftime });
    };
    const storeTimestampContinueButton = (): any => {
        let prooftime = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
        setProofInfo({ ...proofInfo, continueButtonAcceptance: prooftime });
    };  
    const showBillingInformation = (event: any) => {
        handleBillingCloseDialog("show");
    };

    const handleTncDialog = (value: string): any => {
        if (value === "show") {
            setTncDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setTncDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setTncDialog(false);
        }
    };

    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
    });

    const getChangeType = () => {
        if (!props.subscriptionTypeChange && selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return "CANCEL";
        } else if (selectedPackage.ActionButtonText?.toLowerCase() === "purchase") {
            return "PURCHASE";
        } else if (selectedPackage.ActionButtonText?.toLowerCase() === "renew") {
            return "PURCHASE";
        } else return "CHANGE";
    };

    const reverseSubscriptionType = (subscriptionType: string) => {
        if (subscriptionType?.toUpperCase() === "MONTHLY") {
            return "YEARLY";
        } else if (subscriptionType?.toUpperCase() === "YEARLY") {
            return "MONTHLY";
        }
        return "";
    };

    const getSubscriptionType = () => {
        let subscriptionType = selectedPackage?.SubcriptionType;
        if (props.subscriptionTypeChange) {
            subscriptionType = reverseSubscriptionType(subscriptionType);
        }
        return subscriptionType?.toUpperCase();
    };

    const renewUserPaidFamilyMembers = (data: any) => {
        const requestBody = {
            payAsYouGoBillingChargeInfoDetails: payAsYouGoAmountDetailsState,
            familySubAccounts: props.addedFamilyMembers,
            subAccountPk_List_ForRemove: !!props.removedFamilyMembers ? props.removedFamilyMembers.map((member: any) => member.subcustomerId) : [],
            UpgradeDowngradePackageRequest: data,
        };
        setLoading(true);
        services
            .renewPayAsYouGoFamilyMember(requestBody)
            .then((data: any) => {
                if (!data["hasError"]) {
                    getFamilyOffer();
                    getFamilyMembers();
                    setTimeout(function () {
                        showResponseAfterSubmit(data);
                    }, 3000);
                } else {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                        message:
                            data["errors"] && data["errors"].length > 0
                                ? data["errors"][0]
                                : tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                    });
                }
            })
            .catch(function (error) {
                setLoading(false);
                Notification({
                    type: "error",
                    title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                    message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                });
            });
    };
    const onSubmit = (data: any) => {
        const isUserPaidFamilyMembers = props.payAsYouGoPackageDetails ? props.payAsYouGoPackageDetails.isUserPaidFamilyMembers : false;

        const requestBody = {
            packageId: selectedPackage?.PackagId,
            packageCode: selectedPackage?.PackageCode,
            packagePrice:
                isUserPaid && getChangeType() === "CHANGE"
                    ? Number(amountDetailState?.totalCost)
                    : getSubscriptionType() === "YEARLY"
                        ? selectedPackage?.PackagePriceYearly
                        : selectedPackage?.PackagePrice,
            changeType: getChangeType(),
            subscriptionType: getSubscriptionType(),
            billingInformationDTO: billingInfoToSubmit(),
            salesTax: amountDetailState.tax,
            isPayAsYouGoCurrentPackage: isUserPaid,
            familyProtectionCostPerMember: amountDetailState?.familyProtectionCostPerMember ? Number(amountDetailState.familyProtectionCostPerMember) : 0,
            automaticRenewal: submitButtonLabel() !== "Cancel Plan" ? proofInfo.checkBoxAcceptance : "",
            automaticRenewalAcceptance: submitButtonLabel() !== "Cancel Plan" ? proofInfo.continueButtonAcceptance : "",
        };
        const households = familyMembers.filter((x) => x.accountType === "Family Plan Adult")
            ? familyMembers.filter((x) => x.accountType === "Family Plan Adult")
            : [];
        if (isUserPaidFamilyMembers === true && households && households.length > 0) {
            renewUserPaidFamilyMembers(requestBody);
        } else {
            setLoading(true);
            services
                .UpgradeDowngradePackage(requestBody)
                .then((data) => {
                    if (!data["hasError"]) {
                        getFamilyOffer();
                        getFamilyMembers();
                        setTimeout(function () {
                            showResponseAfterSubmit(data);
                        }, 3000);
                    } else {
                        setLoading(false);
                        Notification({
                            type: "error",
                            title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                            message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                        });
                    }
                })
                .catch(function (error) {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                        message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                    });
                });
        }
    };

    const showResponseAfterSubmit = (data: any) => {
        setLoading(false);
        if (data.isSuccess) {
            let subscriptionType = getSubscriptionType() === "YEARLY" ? "New Yearly Subscription" : "New Monthly Subscription";

            let subscriptionCharge = amountDetailState.newCharge;
            let salesTax = amountDetailState.tax;
            let billingText = data && data.billingText ? data.billingText : "";
            let billingAmountLabel = getBillingAmountLabel(data.refundAmount, amountDetailState);
            let billingAmount = Number(amountDetailState.amountTobeCreditedOrCharged);

            const isUserPaidFamilyMembers = props.payAsYouGoPackageDetails ? props.payAsYouGoPackageDetails.isUserPaidFamilyMembers : false;
            const households = familyMembers.filter((x) => x.accountType === "Family Plan Adult")
                ? familyMembers.filter((x) => x.accountType === "Family Plan Adult")
                : [];
            if (isUserPaidFamilyMembers === true && households && households.length > 0) {
                subscriptionCharge = data.userPaidFamilyMultipleSubAccountDetails.payAsYouGoBillingChargeInfoDetails.newCharge;
                salesTax = data.userPaidFamilyMultipleSubAccountDetails.payAsYouGoBillingChargeInfoDetails.tax;
                billingText = data.userPaidFamilyMultipleSubAccountDetails.payAsYouGoBillingChargeInfoDetails.billingText;
                billingAmountLabel = getBillingAmountLabel(data.refundAmount, data);
                billingAmount = Number(data.userPaidFamilyMultipleSubAccountDetails.payAsYouGoBillingChargeInfoDetails.newChargeWithFamilyProtection);
            }
            // to resolve bug 16845
            if (selectedPackage.PartnerId === 428 && billingText) {
                billingAmountLabel =
                    getSubscriptionType() === "YEARLY"
                        ? tLang("manageAccount.protectionPlan.billPaymentPopUp.newYearlySubscription")
                        : tLang("manageAccount.protectionPlan.billPaymentPopUp.newMonthlySubscription");
            } else {
                let nextBillingDate = (billingText && billingText.length >= 6 ? billingText.substring(billingText.indexOf("on the") + 6) : "").trim();
                billingText = tLang("manageAccount.protectionPlan.billPaymentPopUp.billingMsg1");
                if (nextBillingDate) {
                    if (getSubscriptionType() === "YEARLY") {
                        billingText += tLang("manageAccount.protectionPlan.billPaymentPopUp.billingMsg2Annually") + "<strong>" + nextBillingDate + ".</strong>";
                    } else if (getSubscriptionType() === "MONTHLY") {
                        billingText += tLang("manageAccount.protectionPlan.billPaymentPopUp.billingMsg2Monthly") + "<strong>" + nextBillingDate + ".</strong>";
                    }
                }
            }
            if (!props.isTwoStepCancellation) {
                props.closeUpgradeAndOpenCompletionDialog(
                    billingAmount,
                    billingAmountLabel,
                    billingText,
                    subscriptionType,
                    subscriptionCharge,
                    salesTax,
                    amountDetailState.newCharge
                );
            } else {
                billingText = "";
                subscriptionType = "";
                setRefundState({
                    ...refundState,
                    bilingAmount: billingAmount,
                    billingLabel: billingAmountLabel,
                    billingText: billingText,
                    subscriptionType: subscriptionType,
                    subscriptionCharge: String(subscriptionCharge),
                    salesTax: String(salesTax),
                    newCharge: String(amountDetailState.newCharge),
                });
            }
            setCompletion(false);
            setLoader(false);

        } else if (data.errors) {
            Notification({
                type: "error",
                title: dialogTitle(),
                message: data.errors[0],
                duration: 5,
            });
        } else {
            Notification({
                type: "error",
                title: dialogTitle(),
                message: tLang("manageAccount.protectionPlan.notification.couldNotSaveInformationMsg"),
                duration: 5,
            });
        }
    };

    const billingInfoToSubmit = () => {
        if (selectedPackage?.DisplayPaymentInfo) {
            if (!paymentInfoState.paymentMethod && selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
                return null;
            }
            return paymentMethodDetails.data;
        }

        return null;
    };

    const handleCloseEFTDialog = (): any => {
        setEFTDialog(false);
    };
    const checked = () => {
        if (state.isEFTChecked) {
            setState({ ...state, isEFTChecked: false });
            return;
        }
        setState({ ...state, isEFTChecked: true });
    };

    const dialogTitle = () => {
        if (props.subscriptionTypeChange && selectedPackage.IsActive) {
            let from =
                currentPackage?.SubcriptionType?.toLowerCase() === "monthly"
                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.monthly")
                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.yearly");
            let to =
                from.toLowerCase() === "monthly"
                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.yearly")
                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.monthly");
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.subscriptionChangingFromToTitle.text1") +
                from +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.subscriptionChangingFromToTitle.text2") +
                to
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.cancelPlanTitle.text1") +
                selectedPackage.PackageName +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.plan")
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "purchase") {
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.purchasePlanTitle.text1") +
                selectedPackage.PackageName +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.plan")
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "select") {
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.continueToPlanTitle.text1") +
                selectedPackage.PackageName +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.plan")
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "renew") {
            return tLang("manageAccount.protectionPlan.billPaymentPopUp.renew");
        } else {
            return "";
        }
    };

    const submitButtonLabel = () => {
        if (props.subscriptionTypeChange && selectedPackage.IsActive) {
            return "Change Subscription";
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return "Cancel Plan";
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "select") {
            return "Continue";
        } else {
            return selectedPackage?.ActionButtonText;
        }
    };

    const getNewCharge = (data: any) => {
        if (!props.subscriptionTypeChange && selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return 0;
        } else {
            return data.newCharge;
        }
    };

    let disclaimerType = "STATE";
    let stateCode: any = accountInfo?.state;
    let partnerId: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : null
    );
    let retailerCode: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerCode
            ? state.configurationState.configuration.partnerConfig.retailerCode
            : null
    );
    const partnerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    const retailerTollFreeNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerTollFreeNumber
            ? state.configurationState.configuration.partnerConfig.retailerTollFreeNumber
            : ""
    );
   
    const getBillingAmountLabel = (refundAmount: any, data: any) => {

        let label = "";
        let action: any;
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "select") {
            checkupgradedowngrade = getUpgradeDowngradeValue(selectedPackage, currentPackage);
            action = checkupgradedowngrade.toLowerCase();
        }
        else {
            action = selectedPackage?.ActionButtonText?.toLowerCase();
        }

        if (data) {
            if (data.todaysNetCharge) {
                label = tLang("manageAccount.protectionPlan.billPaymentPopUp.label.todaysNetCharge");
            }
            if (data.refundAmount && data.refundAmount !== "0") {
                label = tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourRefundIs");
            }
        }

        return label;
    };

    const getAmountCreditedOrCharged = (data: any) => {
        getBillingAmountLabel(data.refundAmount, data);
        if (data.todaysNetCharge > 0) {
            return data.todaysNetCharge;
        }
        if (data.difference <= 0) {
            if (props.subscriptionTypeChange || checkupgradedowngrade.toLowerCase() === "downgrade") {
                return data.refundAmount;
            } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
                return data.creditedAmount;
            }
        }
        return data.todaysNetCharge;
    };

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => { });
        };
    });


    useEffect(() => {
        const CheckNonCreditService =  () => {
            let productNames = [] as string[];
                if (selectedPackage) {
                    selectedPackage.Products?.forEach((p) => {
                        if (p.name != null && p.name !== "" && p.name !== "--") {
                            productNames.push(p.name);
                        }
                    });
                }
            const result: any =  CheckNonCreditServicesForNCDisclaimer(productNames);
                return result;
        }
        let checkNonCreditResult: string = CheckNonCreditService();
        if (checkNonCreditResult) {
            setCheckNonCredit(checkNonCreditResult);
        }
        let productServiceType = showDisclosure ? "CREDIT" : checkNonCredit;
        const getDisclosureText = async () => {
            if (accountInfo?.country === "US") {
                let result: any = await stateDisclosureAPI(stateCode,
                    disclaimerType, productServiceType,
                    partnerId, retailerCode, null, null);
                return result
            }
        }
        getDisclosureText().then((value: any) => setDisclosureText(value));
    }, [showDisclosure, disclosureText]);

    const getPayAsYouGoAmountDetails = (paymentData: any) => {
        const requestBody = {
            isUserPaidAdultFamilyMembers: false,
            numberOfNewFamilyMemberAdded: 0,
            isRemoveFamilyRequest: props.removedFamilyMembers && props.removedFamilyMembers.length > 0 ? true : false,
            billingChargeInformation: {
                packageId: selectedPackage.PackagId,
                ezshieldId: props.payAsYouGoPackageDetails.userId,
                packageCode: selectedPackage.PackageCode,
                packagePrice: getSubscriptionType() === "YEARLY" ? selectedPackage?.PackagePriceYearly : selectedPackage?.PackagePrice,
                changeType: "PURCHASE",
                subscriptionType: props.payAsYouGoPackageDetails.subscriptionType,
                street1: paymentData.billingAddress.address1,
                street2: paymentData.billingAddress.address2,
                city: paymentData.billingAddress.city,
                country: paymentData.billingAddress.country,
                isAvalaraTaxCalculation: false,
                enrollmentType: "WALKUP",
                region: paymentData.billingAddress.state.selection,
                postalCode: paymentData.billingAddress.zipCode,
            },
            subAccountPk_List_ForRemove:
                props.removedFamilyMembers && props.removedFamilyMembers.length > 0 ? props.removedFamilyMembers.map((member: any) => member.subcustomerId) : [],
            packageId: selectedPackage.PackagId,
        };
        setLoadingAmountDetail(true);

        services.getPayAsYouGoAmountDetails(requestBody).then((data) => {
            try {
                data["amountTobeCreditedOrCharged"] = data.todaysNetCharge;
            } catch { }
            setAmountDetailState(data);
            setPayAsYouAmountDetailsState(data);
            setLoadingAmountDetail(false);
            getTncData({
                packagePrice: Number(getNewCharge(data)),
                packageCode: selectedPackage.PackageCode,
                subscriptionType: props.payAsYouGoPackageDetails.subscriptionType,
                salesTax: data.tax,
            });
        });
    };

    const getPaymentDetailsData = () => {
        if (selectedPackage?.DisplayPaymentInfo) {
            setLoadingPaymentInfo(true);
            services.GetPaymentDetail().then((data) => {
                setLoadingPaymentInfo(false);
                setPaymentMethodDetails({ ...paymentMethodDetails, data });

                if (data.billingAddress != null) {
                    if (!!props.payAsYouGoPackageDetails ? props.payAsYouGoPackageDetails.isUserPaidFamilyMembers : false) {
                        getPayAsYouGoAmountDetails(data);
                    }

                    const billing = data.billingAddress;
                    if (data.creditCard != null && data.creditCard.cardNumber != null) {
                        setPaymentInfoState({
                            ...paymentInfoState,
                            cardOrAccNumber: data.creditCard.cardNumber,
                            name: data.creditCard.nameOnCard,
                            exp: data.creditCard.expDateMo + "/" + data.creditCard.expDateYr,
                            paymentMethod: data.paymentMethod?.selection,
                            address: {
                                addressline1: billing.address1,
                                addressline2: billing.address2,
                                city: billing.city,
                                state: billing.state.selection,
                                zipCode: billing.zipCode,
                            },
                        });
                    } else if (data.eft != null && data.eft.accountNumber != null) {
                        setPaymentInfoState({
                            ...paymentInfoState,
                            cardOrAccNumber: data.eft.accountNumber,
                            name: data.eft.nameOnAccount,
                            paymentMethod: data.paymentMethod?.selection,
                            address: {
                                addressline1: billing.address1,
                                addressline2: billing.address2,
                                city: billing.city,
                                state: billing.state?.selection,
                                zipCode: billing.zipCode,
                            },
                        });
                    }
                }
            });
        }
    };

    const returnDifference = (data: any) => {
        if (props.subscriptionTypeChange) {
            return data.difference;
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return Number(data.currentMonthlyCharge) * -1;
        } else {
            return data.difference;
        }
    };

    const currentChargeFromActivePackage = (): number => {
        let currentCharge: number = 0;
        if (selectedPackage?.ActionButtonText?.toLowerCase() !== "renew") {
            const subscriptionType = currentPackage?.SubcriptionType?.toUpperCase();
            if (subscriptionType === "MONTHLY") {
                currentCharge = currentPackage?.PackagePrice || 0;
            } else {
                currentCharge = currentPackage?.PackagePriceYearly || 0;
            }
        }
        return currentCharge;
    };

    const calculateNewCharge = ({ subscriptionType }: any): number => {
        let newCharge: number = 0;
        if (selectedPackage?.ActionButtonText?.toLowerCase() !== "cancel") {
            if (!subscriptionType) {
                subscriptionType = selectedPackage?.SubcriptionType?.toUpperCase();
            }

            if (subscriptionType === "MONTHLY") {
                newCharge = selectedPackage?.PackagePrice || 0;
            } else {
                newCharge = selectedPackage?.PackagePriceYearly || 0;
            }
        }
        return newCharge;
    };

    const getTncData = ({ packagePrice, packageCode, subscriptionType, salesTax }: any) => {
        setLoadingTnc(true);
        services
            .GetTermsAndConditionsInProtectionPlan({
                billingPrice: packagePrice,
                SubscriptionType: subscriptionType === "MONTHLY" ? "month" : "year",
                SalesTax: salesTax ? Number(salesTax) : 0,
                PackageCode: packageCode,
                IsPreviousbtnClick: false,
            })
            .then((res: any) => {
                setLoadingTnc(false);
                setTermsData(res);
            })
            .catch((err) => {
                setLoadingTnc(false);
            });
    };
    useEffect(() => {
        services.getEFTInfo().then((data: any) => {
            setState({ ...state, EFTData: data });
        });

        getPaymentDetailsData();
    }, []);

    useEffect(() => {
        if (selectedPackage) {
            let productNames = [] as string[];
            selectedPackage.Products?.forEach((p) => {
                if (p.name != null && p.name !== "" && p.name !== "--") {
                    productNames.push(p.name);
                }
            });
            setServiceListOfSelectedPackage(productNames);
        }
    }, [selectedPackage]);

    useEffect(() => {
        props.setBillingInfoRequest(paymentMethodDetails);
    }, [paymentMethodDetails]);
   
    useEffect(() => {
        const requestBody = {
            packagePrice: getSubscriptionType() === "YEARLY" ? selectedPackage?.PackagePriceYearly : selectedPackage?.PackagePrice,
            packageCode: selectedPackage?.PackageCode,
            subscriptionType: getSubscriptionType(),
            country: accountInfo && accountInfo.country ? accountInfo.country : "US",
            region: paymentInfoState.address && paymentInfoState.address.state ? paymentInfoState.address.state : "",
            EnrollmentType: null,
            changeType: "",
            street1: accountInfo && accountInfo.address1 ? accountInfo.address1 : "",
            street2: accountInfo && accountInfo.address2 ? accountInfo.address2 : "",
            city: accountInfo && accountInfo.city ? accountInfo.city : "",
            postalCode: accountInfo && accountInfo.zipCode ? accountInfo.zipCode : "",
            isRemoveFamilyRequest: isUserPaid && submitButtonLabel() === "Cancel Plan" ? true : false,
        };
        if (paymentInfoState && paymentInfoState.address) {
            requestBody.street1 = paymentInfoState.address.addressline1;
            requestBody.street2 = paymentInfoState.address.addressline2;
            requestBody.city = paymentInfoState.address.city;
            requestBody.postalCode = paymentInfoState.address.zipCode;
        }

        if (submitButtonLabel() === "Cancel Plan") {
            requestBody.changeType = "CANCEL";
        }
        if (
            (!!props.payAsYouGoPackageDetails ? !props.payAsYouGoPackageDetails.isUserPaidFamilyMembers : true) ||
            (props.payAsYouGoPackageDetails?.isUserPaidFamilyMembers && !paymentInfoState.cardOrAccNumber)
        ) {
            if (
                (!selectedPackage?.PackageForCacellationContinuation || selectedPackage.ActionButtonText?.toLowerCase() === "renew") &&
                (paymentInfoState.cardOrAccNumber || paymentInfoState.address.state)
            ) {
                setLoadingAmountDetail(true);
                services.getAvalaraService().then(() => {
                    services.getUpgradePackageAmountDetails(requestBody).then((data) => {
                        setAmountDetailState({
                            ...amountDetailState,
                            difference: returnDifference(data),
                            currentCharge: data.currentMonthlyCharge,
                            creditedAmount: data.creditedAmount,
                            newCharge: offerPriceData ? calculateNewCharge({ subscriptionType: requestBody.subscriptionType }) : getNewCharge(data),
                            amountTobeCreditedOrCharged: offerPriceData ? calculateNewCharge({ subscriptionType: requestBody.subscriptionType }) : getAmountCreditedOrCharged(data),
                            nextBillingDate: data.newMonthlyChargeStartFrom,
                            billingCycleDescription1: data.billingCycleDescription1,
                            billingCycleDescription2: data.billingCycleDescription2,
                            billingCycleDescription3: data.billingCycleDescription3,
                            tax: data.tax ? data.tax : "0",
                            familyProtectionCharge: data.familyProtectionCharge ? data.familyProtectionCharge : "0",
                            planCost: data.newCharge ? data.newCharge : 0,
                            totalCost: data.totalCost ? data.totalCost : 0,
                            familyProtectionCostPerMember: data.familyProtectionCostPerMember ? data.familyProtectionCostPerMember : 0,
                            refundAmount: data.refundAmount,
                            todaysNetCharge: data.todaysNetCharge
                        });
                        setLoadingAmountDetail(false);
                        getBillingAmountLabel(data.refundAmount, data);
                        getTncData({
                            packagePrice: offerPriceData ? calculateNewCharge({ subscriptionType: requestBody.subscriptionType }) : Number(getNewCharge(data)),
                            packageCode: requestBody.packageCode,
                            subscriptionType: requestBody.subscriptionType,
                            salesTax: data.tax,
                        });
                        setCompletion(true);
                    });
                });
            } else {
                const difference = calculateNewCharge({ subscriptionType: requestBody.subscriptionType }) - currentChargeFromActivePackage();
                setAmountDetailState({
                    ...amountDetailState,
                    currentCharge: currentChargeFromActivePackage(),
                    newCharge: calculateNewCharge({ subscriptionType: requestBody.subscriptionType }),
                    difference: difference,
                    amountTobeCreditedOrCharged: Math.abs(difference),
                });

                getTncData({
                    packagePrice: requestBody.packagePrice,
                    packageCode: requestBody.packageCode,
                    subscriptionType: requestBody.subscriptionType,
                    salesTax: amountDetailState.tax,
                });
            }
        }
    }, [paymentInfoState.address]);

    useEffect(() => {
        if (isCompleted && props.isTwoStepCancellation) {
            cancelPackage();
        }
    }, [isCompleted]);

    const cancelPackage = () => {
        const isUserPaidFamilyMembers = props.payAsYouGoPackageDetails ? props.payAsYouGoPackageDetails.isUserPaidFamilyMembers : false;

        const requestBody = {
            packageId: selectedPackage?.PackagId,
            packageCode: selectedPackage?.PackageCode,
            packagePrice:
                isUserPaid && getChangeType() === "CHANGE"
                    ? Number(amountDetailState?.totalCost)
                    : getSubscriptionType() === "YEARLY"
                        ? selectedPackage?.PackagePriceYearly
                        : selectedPackage?.PackagePrice,
            changeType: getChangeType(),
            subscriptionType: getSubscriptionType(),
            billingInformationDTO: billingInfoToSubmit(),
            salesTax: amountDetailState.tax,
            isPayAsYouGoCurrentPackage: isUserPaid,
            familyProtectionCostPerMember: amountDetailState?.familyProtectionCostPerMember ? Number(amountDetailState.familyProtectionCostPerMember) : 0,
        };
        const households = familyMembers.filter((x) => x.accountType === "Family Plan Adult")
            ? familyMembers.filter((x) => x.accountType === "Family Plan Adult")
            : [];
        if (isUserPaidFamilyMembers === true && households && households.length > 0) {
            renewUserPaidFamilyMembers(requestBody);
        } else {
            setLoading(true);
            services
                .UpgradeDowngradePackage(requestBody)
                .then((data) => {
                    if (!data["hasError"]) {
                        getFamilyOffer();
                        getFamilyMembers();
                        setTimeout(function () {
                            showResponseAfterSubmit(data);
                        }, 3000);
                    } else {
                        setLoading(false);
                        Notification({
                            type: "error",
                            title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                            message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                        });
                    }
                })
                .catch(function (error) {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                        message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                    });
                });
        }
    };
    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;
            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("TermsAndConditions") !== -1) {
                    return hasSontiqBrand ? (
                        <a href="https://www.sontiq.com/terms-of-use/" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    ) : (
                        <a href={getTermsOfUseURL()} target="_blank">
                            {getTermsOfUseLinkText()}
                        </a>
                    );
                }

                if (attribs.href && attribs.href.indexOf("privacy-policy") !== -1) {
                    return (
                        <a href={getPrivacyNoticeURL()} target="_blank">
                            {getPrivacyNoticeLinkText()}
                        </a>
                    );
                }
            }
        },
    };

    return (
        <React.Fragment>
            {!props.isTwoStepCancellation ?
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <RenderIcons iconName="cube" />
                        </div>
                        <h1>{dialogTitle()}</h1>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} id="protection-plan-upgrade-form-container">
                        <div className={loading || loadingAmountDetail ? "loading dialog-body" : "dialog-body"}>
                            <div className="form-row">
                                <h3 className="content-sub-title">{tLang("manageAccount.protectionPlan.billPaymentPopUp.cartSummary")}</h3>
                            </div>
                            <div className="line-divider margin-vertical-xs"></div>

                            <div className="form-row data-grid has-lines row-height-sm">
                                <fieldset className="form-row inline">
                                    <div className="row data-row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label font-weight-bold" id="label-selected-plan">
                                                <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourPlan")}</strong>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div role="region" className="data-value" aria-labelledby="label-selected-plan">
                                                {selectedPackage?.PackageName}
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            {selectedPackage?.DisplayPaymentInfo && (
                                <div className="form-row data-grid has-lines row-height-sm">
                                    <fieldset className="form-row inline">
                                        <div className="row data-row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label" id="label-payment-info">
                                                    <p>
                                                        <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.paymentInfo")}</strong>
                                                    </p>
                                                </div>
                                            </div>

                                            <div className={"col-xs-12 col-sm-8 col-no-gutter " + (loadingPaymentInfo ? "loading" : "")}>
                                                <div role="region" className="data-value" aria-labelledby="label-payment-info">
                                                    <div className="row between-xs">
                                                        <div className="col-xs col-no-gutter flex-grow-null">
                                                            {paymentInfoState.cardOrAccNumber ? (
                                                                <p>
                                                                    {paymentInfoState.name && (
                                                                        <span>
                                                                            {paymentInfoState.name}
                                                                            <br />
                                                                        </span>
                                                                    )}
                                                                    {paymentInfoState.address.addressline1 && (
                                                                        <span>
                                                                            {paymentInfoState.address.addressline1}
                                                                            <br />
                                                                        </span>
                                                                    )}
                                                                    {paymentInfoState.address.addressline2 && (
                                                                        <span>
                                                                            {paymentInfoState.address.addressline2}
                                                                            <br />
                                                                        </span>
                                                                    )}
                                                                    <span>
                                                                        {[
                                                                            paymentInfoState.address.city,
                                                                            [paymentInfoState.address.state, paymentInfoState.address.zipCode].join(" "),
                                                                        ].join(", ")}
                                                                        <br />
                                                                    </span>
                                                                    <span className="dialog-icon">
                                                                        <em
                                                                            className={
                                                                                "las " +
                                                                                (paymentInfoState.paymentMethod === "CC" ? "la-credit-card " : "la-university ") +
                                                                                "inline-icon"
                                                                            }
                                                                        ></em>{" "}
                                                                        {paymentInfoState.cardOrAccNumber}
                                                                        <br />
                                                                    </span>
                                                                    {paymentInfoState.exp && (
                                                                        <span>
                                                                            {" "}
                                                                            Exp. {paymentInfoState.exp}
                                                                            <br />{" "}
                                                                        </span>
                                                                    )}
                                                                </p>
                                                            ) : (
                                                                <div className="msg-generic msg-small margin-top-xs">
                                                                    <RenderIcons iconName="info-circle" />
                                                                    {tLang("manageAccount.protectionPlan.billPaymentPopUp.label.noPaymentProfile")}
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="col-xs col-no-gutter flex-grow-null">
                                                            <span
                                                                className="default_link"
                                                                onClick={(e) => {
                                                                    showBillingInformation(e);
                                                                    window.addToDataLayer({ event: "Protection Plan - Billing Info" });
                                                                }}
                                                            >
                                                                <a href="javascript:void(0)" className="default_link">
                                                                    {paymentInfoState.cardOrAccNumber
                                                                        ? tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.change")
                                                                        : tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.add")}
                                                                </a>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {!paymentInfoState.paymentMethod && selectedPackage?.ActionButtonText?.toLowerCase() !== "cancel" && (
                                                    <div className="data-value">
                                                        <input
                                                            type="text"
                                                            name="paymentMethod"
                                                            id="label-payment-method"
                                                            defaultValue={paymentInfoState.paymentMethod}
                                                            ref={register({ required: true })}
                                                            style={{ opacity: 0, height: 0, width: 0, float: "left" }}
                                                            aria-labelledby="label-payment-info"
                                                        />
                                                        {errors["paymentMethod"] && errors["paymentMethod"].type === "required" && (
                                                            <span className="form-error">
                                                                {tLang("manageAccount.protectionPlan.billPaymentPopUp.validation.paymentInfoRequired")}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            )}

                            {!selectedPackage?.PackageForCacellationContinuation && (
                                <div className="form-row data-grid has-lines row-height-sm">
                                    <fieldset className="form-row inline">
                                        <div className="row data-row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label" id="label-current-charge">
                                                    <strong>
                                                        {currentPackage ? (
                                                            <React.Fragment>
                                                                {currentPackage?.SubcriptionType?.toUpperCase() === "MONTHLY"
                                                                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.monthlyCharge")
                                                                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yearlyCharge")}
                                                            </React.Fragment>
                                                        ) : (
                                                            <React.Fragment>
                                                                {selectedPackage?.SubcriptionType?.toUpperCase() === "MONTHLY"
                                                                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.monthlyCharge")
                                                                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yearlyCharge")}
                                                            </React.Fragment>
                                                        )}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div role="region" className="data-value" aria-labelledby="label-current-charge">
                                                    ${Number(amountDetailState.currentCharge).toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            )}

                            <div className="form-row data-grid has-lines row-height-sm">
                                {((isUserPaid && submitButtonLabel() === "Cancel Plan") || (Number(amountDetailState.tax) > 0 && selectedPackage)) && (
                                    <fieldset className="form-row inline">
                                        <div className="row data-row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label" id="label-plan-cost">
                                                    <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.planCost")}</strong>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div role="region" className="data-value" aria-labelledby="label-plan-cost">
                                                    {isUserPaid && submitButtonLabel() === "Cancel Plan"
                                                        ? formatter.format(amountDetailState.planCost)
                                                        : formatter.format(amountDetailState.newCharge)}
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                )}
                                {isUserPaid &&
                                    getChangeType() === "CHANGE" &&
                                    (selectedPackage?.PackagePriceYearly > 0 || selectedPackage?.PackagePrice > 0) &&
                                    amountDetailState.familyProtectionCharge &&
                                    Number(amountDetailState.familyProtectionCharge) > 0 && (
                                        <fieldset className="form-row inline">
                                            <div className="row data-row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="label-plan-cost">
                                                        <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.planCost")}</strong>
                                                    </div>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div role="region" className="data-value" aria-labelledby="label-plan-cost">
                                                        {isUserPaid && getChangeType() === "CHANGE"
                                                            ? formatter.format(
                                                                getSubscriptionType() === "YEARLY" ? selectedPackage?.PackagePriceYearly : selectedPackage?.PackagePrice
                                                            )
                                                            : formatter.format(0)}
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    )}
                                {isUserPaid && Number(amountDetailState.familyProtectionCharge) > 0 ? (
                                    <fieldset className="form-row inline">
                                        <div className="row data-row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label" id="label-sales-tax">
                                                    <strong>
                                                        {tLang("manageAccount.protectionPlan.billPaymentPopUp.label.familyProtection")}{" "}
                                                        {householdMembers ? `X ${householdMembers.length}` : ""}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div role="region" className="data-value" aria-labelledby="label-sales-tax">
                                                    ${Number(amountDetailState.familyProtectionCharge).toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                ) : (
                                    <></>
                                )}
                                {(submitButtonLabel() === "Cancel Plan" && Number(amountDetailState.tax) >= 0) || Number(amountDetailState.tax) > 0 ? (
                                    <fieldset className="form-row inline">
                                        <div className="row data-row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label" id="label-sales-tax">
                                                    <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.salesTax")}</strong>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div role="region" className="data-value" aria-labelledby="label-sales-tax">
                                                    ${Number(amountDetailState.tax).toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                ) : null}

                                <fieldset className="form-row inline">
                                    <div className="row data-row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="label-monthly-charge">
                                                <strong>
                                                    {getSubscriptionType()?.toUpperCase() === "MONTHLY"
                                                        ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.newMonthlyCharge")
                                                        : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.newYearlyCharge")}
                                                </strong>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div role="region" className="data-value" aria-labelledby="label-monthly-charge">
                                                {Number(amountDetailState.tax)
                                                    ? "$" + (Number(amountDetailState.newCharge) + Number(amountDetailState.tax)).toFixed(2)
                                                    : "$" + Number(amountDetailState.newCharge).toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                {(!!props.payAsYouGoPackageDetails ? props.payAsYouGoPackageDetails.isUserPaidFamilyMembers : false) &&
                                    submitButtonLabel() === "Renew" &&
                                    Number(amountDetailState.familyProtectionCharge) > 0 ? (
                                    <fieldset className="form-row inline">
                                        <div className="row data-row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label" id="label-sales-tax">
                                                    <strong>
                                                        {tLang("manageAccount.protectionPlan.billPaymentPopUp.label.familyProtection")}{" "}
                                                        {props.addedFamilyMembers ? `X ${props.addedFamilyMembers.length}` : ""}
                                                    </strong>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div role="region" className="data-value" aria-labelledby="label-sales-tax">
                                                    ${Number(amountDetailState.familyProtectionCharge).toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                ) : (
                                    <></>
                                )}
                            </div>
                            {!selectedPackage?.PackageForCacellationContinuation &&
                                Number(amountDetailState.amountTobeCreditedOrCharged) !== Math.abs(amountDetailState.difference) &&
                                submitButtonLabel() !== "Cancel Plan" && (
                                    <div className="form-row data-grid has-lines row-height-sm">
                                        <fieldset className="form-row inline">
                                            <div className="row data-row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="label-difference">
                                                        <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.difference")}</strong>
                                                    </div>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div role="region" className="data-value" aria-labelledby="label-difference">
                                                        {Number(amountDetailState.difference) < 0
                                                            ? "-$" + (Number(amountDetailState.difference) * -1).toFixed(2)
                                                            : "$" + Number(amountDetailState.difference).toFixed(2)}
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                )}

                            <div className="form-row data-grid row-height-sm">
                                <fieldset className="form-row inline">
                                    <div className="row data-row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="label-todays-charge">
                                                <h4 className="status-good">{getBillingAmountLabel(amountDetailState.refundAmount, amountDetailState)}</h4>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div role="region" className="data-value" aria-labelledby="label-todays-charge">
                                                <div className="row between-xs">
                                                    <div className="col-xs col-no-gutter flex-grow-null">
                                                        <h4 className="status-good">{"$" + Number(amountDetailState.amountTobeCreditedOrCharged).toFixed(2)}</h4>
                                                    </div>
                                                    {!selectedPackage?.PackageForCacellationContinuation &&
                                                        !(selectedPackage?.ActionButtonText?.toLowerCase() === "purchase") &&
                                                        paymentInfoState.cardOrAccNumber &&
                                                        Number(amountDetailState.currentCharge) !== 0 && (
                                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                                <button
                                                                    aria-expanded="false"
                                                                    type="button"
                                                                    className="btn-default btn-toggle btn-no-padding"
                                                                    id="btn_calculation_rule"
                                                                    onClick={() => toggle("calculation_rule", "btn_calculation_rule")}
                                                                >
                                                                    <span className="btn-toggle-status sr-only">
                                                                        {tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.show")}
                                                                    </span>
                                                                    <span className="btn-text">
                                                                        {tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.calculated")}
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>

                                                <div id="calculation_rule" style={{ display: "none" }}>
                                                    <br />
                                                    <p>{parse(amountDetailState.billingCycleDescription1)}</p>
                                                    <p>{parse(amountDetailState.billingCycleDescription2)}</p>
                                                    <p>{parse(amountDetailState.billingCycleDescription3)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <div className="margin-bottom-l"></div>
                                <WhatYouNeedToKnow serviceList={serviceListOfSelectedPackage} selectedCountry={accountInfo?.country} showDisclosureStatus={showDisclosureStatus} />

                            </div>

                            {disclosureText ?
                                <div>
                                    <div className="line-divider margin-vertical-xs"></div>
                                    <div className="cardDisclosure" style={{ paddingTop: "20px", paddingBottom: "25px" }} dangerouslySetInnerHTML={{ __html: disclosureText }}>
                                    </div></div> : ""}

                            <div className="msg-generic " >
                                {submitButtonLabel() !== "Cancel Plan" ?
                                    <>
                                        <div className="margin-bottom-l"></div>
                                        <h2 className="automatic-renewal"> {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.yearly-automatic-renewal") : tLang("registration.billing.renewal-disclosure.monthly-automatic-renewal")}</h2>
                                        <div className="margin-bottom-l"></div> </> : ""}
                                <div className="form-row data-grid">
                                    <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="isAgreed">
                                            <input type="checkbox" id="isAgreed" name="isAgreed" onChange={toggleDisableButton} onClick={storeTimestampCheckbox} ref={register({ required: true })} />
                                            {submitButtonLabel() === "Cancel Plan" ? (
                                                <span className="form-checkbox-label-text">
                                                    {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.byCheckingBox")}
                                                    <span className="default_link">
                                                        &nbsp;
                                                        {hasSontiqBrand ? (
                                                            <a href="https://www.sontiq.com/terms-of-use/" target="_blank">
                                                                {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.termsOfUse")}
                                                            </a>
                                                        ) : (
                                                            <a
                                                                href={getTermsOfUseURL()}
                                                                target="_blank"
                                                                onClick={() => {
                                                                    window.addToDataLayer({ event: "Protection Plan - Show TNC" });
                                                                }}
                                                            >
                                                                {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.termsOfUse")}
                                                            </a>
                                                        )}{" "}
                                                        {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.and")}{" "}
                                                        <a href={getPrivacyNoticeURL()} target="_blank">
                                                            {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.privacyNotice")}
                                                        </a>
                                                        .
                                                    </span>
                                                </span>
                                            ) : (

                                                <span className="form-checkbox-label-text" style={{ paddingTop: "0.3rem" }}>
                                                    {tLang("registration.billing.renewal-disclosure.renewalText1")}
                                                    {Number(amountDetailState.newCharge).toFixed(2)} {tLang("registration.billing.renewal-disclosure.renewalText2")} {" "} {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.an-annual") : tLang("registration.billing.renewal-disclosure.a-monthly")}{" "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText3")}
                                                    {Number(amountDetailState.newCharge).toFixed(2)} {tLang("registration.billing.renewal-disclosure.renewalText4")} {" "}
                                                    {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.year") : tLang("registration.billing.renewal-disclosure.month")} {" "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText5")} {" "}
                                                    {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.annual") : tLang("registration.billing.renewal-disclosure.monthly")} {tLang("registration.billing.renewal-disclosure.renewalText6")} {" "} {getSubscriptionType() === "YEARLY" ? "date " : "day "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText7")} {" "}
                                                    {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.year") : tLang("registration.billing.renewal-disclosure.month")} {tLang("registration.billing.renewal-disclosure.renewalText8")} {" "}
                                                    <div className="margin-bottom-l"></div>
                                                    <legend className="legend-label">{tLang("registration.billing.renewal-disclosure.cancellation")}</legend>
                                                    {tLang("registration.billing.renewal-disclosure.renewalText9")} {" "} {retailerTollFreeNumber ? retailerTollFreeNumber : partnerPhoneNumber}.

                                                    {tLang("registration.billing.renewal-disclosure.renewalText10")} {" "}
                                                    <div className="By-checking-box">
                                                        <div className="margin-bottom-l"></div>
                                                        {tLang("registration.billing.terms-of-Use.terms-Text2")}{" "}

                                                        <a
                                                            href="https://www.sontiq.com/terms-of-use/"
                                                            target="_blank"
                                                            className="text-style-1"
                                                        >
                                                            Terms of Use
                                                        </a>
                                                        {" "}
                                                        and
                                                        {" "}

                                                        <a
                                                            href="https://www.sontiq.com/privacy-policy"
                                                            target="_blank"
                                                            className="text-style-2"
                                                        >
                                                            {" "}
                                                            Privacy Notice
                                                        </a>
                                                        .
                                                    </div>

                                                </span>
                                            )}
                                            {errors["billingAddress"] && <span className="form-error">{errors.billingAddress.message}</span>}
                                            {errors["isAgreed"] && errors["isAgreed"].type === "required" && (
                                                <span className="form-error">{tLang("manageAccount.protectionPlan.billPaymentPopUp.validation.agreetancRequired")}</span>
                                            )}
                                        </label>
                                    </div>
                                </div>

                                {paymentInfoState.paymentMethod === "EFT" && (
                                    <div className="form-row data-grid">
                                        <div className="form-input">
                                            <label className="form-checkbox-label" htmlFor="isEFTChecked">
                                                <input type="checkbox" id="isEFTChecked" name="isEFTChecked" ref={register({ required: true })} onChange={() => checked()} />
                                                <span className="form-checkbox-label-text">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.I")}
                                                    <span
                                                        className="default_link"
                                                        onClick={() => {
                                                            setEFTDialog(true);
                                                            window.addToDataLayer({ event: "Protection Plan - EFT Acknowledgement" });
                                                        }}
                                                    >
                                                        &nbsp;
                                                        <a href="javascript:void(0)" className="default_link">
                                                            {tLang("manageAccount.protectionPlan.billingInformation.validation.authorize")}
                                                        </a>
                                                        &nbsp;
                                                    </span>
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.bankInfo")}
                                                </span>

                                                {errors["isEFTChecked"] && errors["isEFTChecked"].type === "required" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.protectionPlan.billingInformation.validation.checkAuthRequired")}
                                                    </span>
                                                )}
                                            </label>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null"></div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button
                                        type="submit"
                                        className="btn-default btn-primary"
                                        id="btn-submit-purchase"
                                        disabled={loadingPaymentInfo || loadingAmountDetail || loadingTnc || disableButton}
                                        onClick={() => window.addToDataLayer({ event: "Protection Plan - Submit " + selectedPackage?.ActionButtonText?.toUpperCase() })}
                                    >
                                        <span className="btn-text" onClick={storeTimestampContinueButton}>{submitButtonLabel()}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    {showBillingInfoDialog && (
                        <DialogComponent
                            dialogId="protection-plan-billing-information-dialog"
                            title={tLang("manageAccount.protectionPlan.billingInformation.title")}
                            datalayerEvent="Protection Plan - Close billing info"
                            closeDialog={() => {
                                handleBillingCloseDialog("close");
                            }}
                        >
                            <ProtectionPlanBillingInfo
                                dialogId="protection-plan-billing-information-dialog"
                                setBillingInfoChanged={props.setBillingInfoChanged}
                                closeDialog={() => {
                                    handleBillingCloseDialog("close");
                                }}
                                getSubscriptionType={getSubscriptionType}
                                selectedPackage={selectedPackage}
                            ></ProtectionPlanBillingInfo>
                        </DialogComponent>
                    )}

                    {tncDialog && (
                        <DialogComponent
                            dialogId="protection-plan-tnc-dialog"
                            title={tLang("manageAccount.protectionPlan.termsNConditions.title")}
                            datalayerEvent="Protection Plan - Close TNC"
                            closeDialog={() => handleTncDialog("close")}
                        >
                            <ProtectionPlanTermsAndCondition
                                dialogId="protection-plan-tnc-dialog"
                                closeDialog={() => handleTncDialog("close")}
                                packageIndex={props.packageIndex}
                            ></ProtectionPlanTermsAndCondition>
                        </DialogComponent>
                    )}

                    {EFTdialog && (
                        <DialogComponent
                            dialogId="whatsIncluded"
                            hideCloseButton={true}
                            title={tLang("manageAccount.protectionPlan.billPaymentPopUp.yourCart")}
                            closeDialog={handleCloseEFTDialog}
                        >
                            <EFTDialog data={state.EFTData} closeDialog={handleCloseEFTDialog}></EFTDialog>
                        </DialogComponent>
                    )}
                </>
                : isLoader ?
                    <div className="col-xs">
                        <div className={`box offset-padding loading`}></div>
                    </div> :
                    <ProtectionPlanUpgradeCompleteDialog
                        dialogId="protection-plan-upgrade-done-dialog"
                        closeDialog={() => { }}
                        billingLabel={refundState.billingLabel}
                        billingAmount={refundState.bilingAmount}
                        billingText={refundState.billingText}
                        subscriptionType={refundState.subscriptionType}
                        subscriptionCharge={refundState.subscriptionCharge}
                        salesTax={refundState.salesTax}
                        selectedPackage={selectedPackage}
                        subscriptionTypeChange={props.subscriptionTypeChange}
                        newCharge={refundState.newCharge}
                        isTwoStepCancellation={props.isTwoStepCancellation}
                    />
            }
        </React.Fragment>
    );
};
export default ProtectionPlanUpgradePackage;
